export default "/fonts/vendor/mdui/dist/roboto/Roboto-Light.woff2?3b9222bb69292e15261d91b1e6393369";